import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import MessageThread from "@/components/MessageThread";
import MessageComposer from "@/components/MessageComposer";

export default function LearnerMessages() {
  const [messages, setMessages] = useState([]);
  const threadEndScroll = useRef();

  const load = () => api.get("/learner/messages").then(({ data }) => setMessages(data));
  useEffect(() => { load(); }, []);
  useEffect(() => { threadEndScroll.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

  const send = async (payload) => {
    await api.post("/learner/messages", payload);
    await load();
  };

  return (
    <div className="lg:ml-56">
      <h1 className="font-serif-accent text-3xl sm:text-4xl">Messagerie</h1>
      <p className="text-[#5C6561] mt-1 mb-4 text-sm">Échangez directement avec votre coach.</p>

      <div className="dec-card overflow-hidden flex flex-col h-[70vh]" data-testid="learner-messages">
        <MessageThread messages={messages} me="learner" />
        <div ref={threadEndScroll} />
        <MessageComposer uploadPath="/learner/upload" onSend={send} placeholder="Répondre à votre coach…" />
      </div>
    </div>
  );
}
